(function() {

    // Add the directive to the module
    angular.module("Sinewav3.Client.Shell")
        .directive(
            'anonMenu',
            [
                'CHROME',
                AnonMenuFactory
            ]
        );

    // Factory Method
    function AnonMenuFactory(CHROME)
    {
        // Construct and return the instance
        return {
            restrict: 'E',
            templateUrl: CHROME.PREFIX + CHROME.MENU.ANON + CHROME.POSTFIX
        };

    }
})();



